export type IExemptionPropertyDamagedFormSeventhSection = {
    Signature?: string,
    SignatureDate?: string,
}

export const ExemptionPropertyDamagedFormSeventhSectionInterface = (): IExemptionPropertyDamagedFormSeventhSection => ({
    Signature: undefined,
    SignatureDate: undefined,
})